module.exports = __webpack_public_path__ + "static/feature-explain-86f03cacee3e658c5b148bdeac789893.mp4";